<template>
  <div class="wg-row com-anm22-app-inner-wrapper">
    <div v-if="loading" class="wg-row" style="align-items:center;justify-content:center;">
      <vue-simple-spinner size="medium" :line-fg-color="appColor"></vue-simple-spinner>
    </div>
    <template v-else>
      <!-- TITLE -->
      <div class="wg-row">
        <div class="com-anm22-app-text-xxl" style="margin:10px 0;">
          {{ $anm22.strLang(lang, 'Tables map', 'Mappa dei tavoli') }}
        </div>
      </div>
      <div class="vertical-height-div" style="height:10px;"></div>
      <!-- MAP -->
      <div class="wg-row" :style="{ height: mapHeight + 'px'}">
        <tables-manage
          :canViewList="true"
          :freeFn="table => $router.push('takeOrder/?tableId='+table.id)"
          :occupiedFn="order => $router.push('takeOrder/'+order.id)"
        ></tables-manage>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import TablesManage from '../../components/tables/TablesManage.vue';
import Spinner from 'vue-simple-spinner';

export default {
  data() {
    return {
      loading: true,
      updateInterval: null
    }
  },
  components: {
    TablesManage,
    'vue-simple-spinner': Spinner
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      lang: state => state.lang,
      licenseSelected: state => state.licenseSelected,
      windowWidth: state => state.windowWidth,
      windowHeight: state => state.windowHeight,
      isOffline: state => state.offline.isOffline,
      appColor: state => state.config.appColor
    }),
    mapHeight() {
      return this.windowHeight - 140;
    },
    license() {
      return this.$store.getters['foodLicenses/getByHash'](this.licenseSelected);
    },
    work() {
      return this.$store.getters['works/get'](this.license.work);
    },
  },
  methods: {
    loadData() {
      return Promise.all(
        [
          this.$store.dispatch('foodLicenses/load', this.$vlf('foodLicenses')),
          this.$store.dispatch('foodEmployments/load', this.$vlf('foodEmployments')),
          this.$store.dispatch('foodAcs/load', this.$vlf('foodAcs')),
          this.$store.dispatch('foodRooms/load', this.$vlf('foodRooms')),
          this.$store.dispatch('foodTables/load', this.$vlf('foodTables')),
          this.$store.dispatch('works/load', this.$vlf('works')),
          this.$store.dispatch('foodOrders/load', this.$vlf('foodOrders')),
        ]
      );
    },
    async updateData() {
      if (!this.isOffline) {
        try {
          const response = await this.$http.get("tables/refresh");
          this.$store.dispatch("foodTables/update",{
            vlf: this.$vlf('foodTables'), objs: response.data.tables,
            cleanFilters: [t => t.license === this.license.id]
          }),
          this.$store.dispatch("foodOrders/update",{
            vlf: this.$vlf('foodOrders'), objs: response.data.orders
          })
        } catch (e) {}
      }
    }
  },
  created() {
    if(!this.license.config.modules.tables.enabled) {
      this.$router.push('/').catch(e => console.log(e));
      return;
    }
    document.title = this.$anm22.strLang(this.lang, "Tables", "Tavoli");
    this.$store.dispatch(
      "headbar/setHeadbarTitle",
      this.$anm22.strLang(this.lang, "Tables", "Tavoli")
    );
    this.loadData();
    //Get orders
    this.$http
      .get("tables")
      .then(response => {
        Promise.all([
          this.$store.dispatch("foodLicenses/update",{
            vlf: this.$vlf('foodLicenses'), objs: response.data.foodLicenses
          }),
          this.$store.dispatch("foodEmployments/update",{
            vlf: this.$vlf('foodEmployments'), objs: response.data.foodEmployments
          }),
          this.$store.dispatch("foodAcs/update",{
            vlf: this.$vlf('foodAcs'), objs: response.data.foodAcs
          }),
          this.$store.dispatch("foodRooms/update",{
            vlf: this.$vlf('foodRooms'), objs: response.data.rooms
          }),
          this.$store.dispatch("foodTables/update",{
            vlf: this.$vlf('foodTables'), objs: response.data.tables
          }),
          this.$store.dispatch("works/update",{
            vlf: this.$vlf('works'), objs: response.data.works
          }),
          this.$store.dispatch("foodOrders/update",{
            vlf: this.$vlf('foodOrders'), objs: response.data.orders
          }),
          this.$store.dispatch("foodOrderElements/update",{
            vlf: this.$vlf('foodOrderElements'), objs: response.data.orderElements
          })
        ])
        .then(() => {
          this.loading = false;
          this.$Progress.finish();
        });
      })
      .catch(error => {
        this.loadData()
        .then(() => {
          this.loading = false;
          this.$Progress.finish();
        });
      });
  },
  destroyed() {
    clearInterval(this.updateInterval);
  },
  mounted() {
    this.$nextTick(() => {
      this.updateInterval = setInterval(() => {
        this.updateData();
      }, 30000);
    });
  }
}
</script>

<style lang="scss" scoped>

</style>
